import React, { Component } from 'react'
import 'react-placeholder/lib/reactPlaceholder.css'

class ButtonsPlaceholder extends Component {
  render () {
    return (
      <div className='card-buttons row px-2 border-color-ui-3 pb-3 mx-0 '>
        <div className='card-button col-6 pl-0'>
          <div className='col-12 pt-4 pb-2 radius bg-ui-3 mb-1' />
        </div>
      </div>
    )
  }
}

export default ButtonsPlaceholder



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/AddCart/ButtonsPlaceholder.js